export var IProductBasedCollectionPromo;
(function (IProductBasedCollectionPromo) {
    let Type;
    (function (Type) {
        Type["TYPE_UNKNOWN"] = "TYPE_UNKNOWN";
        /**
         * This promo type gives retailers a display for free if they meet the promo minimum.
         */
        Type["FREE_DISPLAY"] = "FREE_DISPLAY";
    })(Type = IProductBasedCollectionPromo.Type || (IProductBasedCollectionPromo.Type = {}));
    let QualificationType;
    (function (QualificationType) {
        QualificationType["QUALIFICATION_TYPE_UNKNOWN"] = "QUALIFICATION_TYPE_UNKNOWN";
        /**
         * Retailer qualifies for the promotion only if they spend a minimum amount.
         */
        QualificationType["MINIMUM_AMOUNT"] = "MINIMUM_AMOUNT";
        /**
         * Retailer qualifies for the promotion only if they order a minimum quantity.
         * @deprecated
         */
        QualificationType["MINIMUM_QUANTITY"] = "MINIMUM_QUANTITY";
    })(QualificationType = IProductBasedCollectionPromo.QualificationType || (IProductBasedCollectionPromo.QualificationType = {}));
    /**
     * Return an instance of IProductBasedCollectionPromo with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IProductBasedCollectionPromo.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IProductBasedCollectionPromo || (IProductBasedCollectionPromo = {}));
